// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "@tailwindplus/elements";
import "./controllers";
import "./channels";
import "./src";

import * as Lexxy from "@37signals/lexxy";
import { AssetPickerExtension } from "./extensions/asset_picker_extension";

// Configure Lexxy extensions before the custom element is defined.
Lexxy.configure({
  global: {
    extensions: [ AssetPickerExtension ],
  },
});

import "@rails/actiontext";
require("@rails/activestorage").start();
import ahoy from "ahoy.js";
